import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Typography
} from "../ui/ot";
import { Form } from "antd";

import dayjs from "dayjs";
import AppointmentForm from "./views/AppointmentForm";
import { useAppointment } from "./controller/AppointmentController";
import { text } from "@fortawesome/fontawesome-svg-core";
const { Title, Paragraph, Text, Link } = Typography;

const Appointment = ({ prefixTitle = "" }) => {
    // const [messageApi, contextHolder] = message.useMessage();
    // const [grade_option, set_grade_option] = useState([]);
    // const [learn_english_year, set_learn_english_year] = useState([]);
    // const [agree, set_agree] = useState(false);
    // const [additional_test, set_additional_test] = useState('');
    const [form_data, set_form_data] = useState([]);
    // const [modal_contract, set_modal_contract] = useState(false)

    const onFormFinish = (values) => {
        // if (axiosMode === "post") {
        postAppointmentData([values]);
        // }
        // else if (axiosMode === "patch") {
        //     patchNewsData([values])
        // }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("送出成功");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                // actionRef.current.reloadAndRest();
                // setSelectedRowKeys([])
                // setSelectedRowsInfo([])
            }
            // setModalLoading(false)
            // setModalOpen(false)
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    };
    const {
        // getAppointmentData,
        postAppointmentData,
        // patchAppointmentData,
        // deleteAppointmentData,
    } = useAppointment({
        onFinish,
        onBefore,
    });

    useEffect(() => {
        console.log(form_data);
        document.title = `${prefixTitle} | 聯絡我們`;
    }, [form_data]);
    return (
        <Row gutter={[8, 8]}
            justify={'center'}
            align={'middle'}
            style={{
                padding: "1rem"
            }}
        >
            <Col span={20}>
                <Title level={2}
                    style={{
                        textAlign: 'center'
                    }}>
                    聯絡我們
                </Title>
            </Col>
            <Col
                xxl={12}
                xl={12}
                lg={12}
                md={20}
                sm={20}
                xs={20}
            >
                <AppointmentForm onFormFinish={onFormFinish}></AppointmentForm>
            </Col>

        </Row>
    );
};
const AppointmentManagement = ({ prefixTitle = "" }) => {
    const columns = [
        {
            title: "姓名",
            key: "name",
            dataIndex: "name",
            align: "center",
        },
        {
            title: "聯絡電話",
            key: "phone",
            dataIndex: "phone",
            align: "center",
        },
        {
            title: "電子信箱",
            key: "email",
            dataIndex: "email",
            align: "center",
        },
        {
            title: "服務單位",
            key: "service_unit",
            dataIndex: "service_unit",
            align: "center",
        },
        {
            title: "內容",
            key: "content",
            dataIndex: "content",
            align: "center",
        },
        {
            title: "諮詢時間",
            key: "date_and_time",
            dataIndex: "date_and_time",
            align: "center",
        },
        {
            title: "操作",
            valueType: "option",
            key: "option",
            fixed: "right",
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (

                    <Popconfirm
                        title="刪除項目"
                        description="確定刪除勾選項目?"
                        onConfirm={() => handleDeleteRow(record?.contact_id)}
                        onCancel={() => { }}
                    >
                        <Button type="link" danger>
                            刪除
                        </Button>
                    </Popconfirm>
                );
            },
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.contact_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.contact_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record.contact_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record.contact_id);
                selectRow = selectRow.filter(
                    (row) => row.contact_id !== record.contact_id
                );
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get");
    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);
        let news_time = dayjs(record?.news_time, "YYYY-MM-DD HH:mm:ss");
        let announce_time_end = record?.announce_time_end
            ? dayjs(record?.announce_time_end, "YYYY-MM-DD HH:mm:ss")
            : record?.announce_time_end;

        form.resetFields();
        form.setFieldsValue({
            ...record,
            news_time,
            announce_time_end,
        });
    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    contact_id: id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    contact_id: val?.contact_id,
                };
            });
        }
        if (data.length > 0) {
            deleteAppointmentData(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            // postNewsData([values])
        } else if (axiosMode === "patch") {
            // patchNewsData([values])
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
            setModalLoading(false);
            setModalOpen(false);
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useTableColumnsCheck(columns);

    const {
        getAppointmentData,
        // postAppointmentData,
        // patchAppointmentData,
        deleteAppointmentData,
    } = useAppointment({
        onFinish,
        onBefore,
    });

    useEffect(() => {
        document.title = `${prefixTitle} | 諮詢管理`;

        checkAll();
    }, []);

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Typography.Title
                    level={3}
                >
                    諮詢管理
                </Typography.Title>
                <ProTableOt
                    actionRef={actionRef}
                    headerTitle={<></>}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    rowKey={"contact_id"}
                    selections={
                        {
                            // onChange: (index_, data_) => set_data(data_)
                        }
                    }
                    toolBarRender={() => [
                        <Popconfirm
                            title="刪除諮詢名單"
                            description="確定刪除勾選諮詢名單?"
                            onConfirm={() => handleDeleteRow()}
                            onCancel={() => { }}
                        >
                            <Button
                                type="primary"
                                style={{
                                    color: "#000",
                                    backgroundColor: "#ffedee",
                                }}
                            >
                                刪除諮詢名單
                            </Button>
                        </Popconfirm>,
                    ]}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={false}
                    request={async (params = {}, sort, filter) => {
                        setAxiosMode("get");
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        setPageSize(params?.pageSize ?? 20);

                        return getAppointmentData(newParams);
                        // return []
                    }}
                    pageSize={pageSize}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }}
                    tableAlertOptionRender={() => {
                        return (
                            <></>
                        );
                    }}
                    tableAlertRender={({
                        selectedRowKeys,
                        selectedRows,
                        // onCleanSelected,
                    }) => {
                        return (
                            <>
                                <span>
                                    已選擇 {selectedRowKeys.length} 項
                                    <a
                                        style={{ marginInlineStart: 8 }}
                                        onClick={onCleanSelected}
                                    >
                                        取消選擇
                                    </a>
                                </span>
                            </>
                        );
                    }}
                    scroll={{
                        x: "max-content",
                    }}
                />
            </Col>
        </Row>
    );
};

const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};
export default Appointment;
export { AppointmentManagement };
